import React from "react"
import { Button, Modal, Typography, Space } from "antd"
import { DownloadOutlined } from "@ant-design/icons"
import PropTypes from "prop-types"
import { useAuth } from "../../../contexts/auth"
import { useMutation } from "@apollo/client"
import { createDownloadLog } from "../../../graphql/submission/mutations/createDownloadLog"

export function DataExportModal({
  exportLoading,
  exportUrl,
  onCancel,
  ...props
}) {



   const auth = useAuth()
   const userAuthDownload = auth?.user?.claims ?? {}

  /** Function to register data of downloaded documents **/
 
   const handleDownload = () => {
    if (!userAuthDownload) {
      console.error("No user information available")
      return
    }

    const downloadInfo = {
      email: userAuthDownload.email,
      userName: userAuthDownload.name,
      role: userAuthDownload.role,
      uid: userAuthDownload.user_id,
      documentName: "Asistentes.xml",
    }

    trackDownload({
      variables: { data: downloadInfo }
    })
      .catch((error) => {
        console.error(error)
      })

  }

  const [trackDownload] = useMutation(createDownloadLog)

  return (
    <Modal
      title="Exportar"
      onCancel={onCancel}
      footer={[
        <Button
          type="primary"
          loading={exportLoading}
          key="cancel"
          onClick={onCancel}>
          Cerrar
        </Button>
      ]}
      {...props}>
      {exportLoading
        ? <Typography.Title
            style={{ textAlign: "center" }}
            level={5}>
          Espera un momento, tu archivo se está generando
        </Typography.Title>
        : (
          <Space
            direction="vertical" align="center"
            style={{ width: "100%" }}>
            <Typography.Title
              style={{ textAlign: "center" }}
              level={5}>
              Tu archivo se generó correctamente
            </Typography.Title>
            <a
              target="_blank"
              rel="noreferrer"
              href={exportUrl}
              onClick={() => handleDownload()}
              style={{
                color: "#612F5E",
                textDecoration: "none"
              }}
            >
              <DownloadOutlined
              style={{color: "#612F5E"}} /> Descárgalo aquí
            </a>
          </Space>
        )
      }
    </Modal>
  )
}


DataExportModal.propTypes = {
  onCancel: PropTypes.func,
  exportUrl: PropTypes.string,
  exportLoading: PropTypes.bool
}
